export default __webpack_public_path__ + "static/media/info-trail.650a478b.png";